import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useField } from "@madmedical/form";
import BaseDateInput from "../molecules/Form/DateInput";
import FormControlWrapper from "../molecules/Form/FormControlWrapper";
const DateInput = ({ name, isRequired, label, labelProps, isDefaultToday = true, }) => {
    const { control, isError, error } = useField(name);
    const dateValue = (value) => {
        if (!isDefaultToday && !value) {
            return undefined;
        }
        if (!value) {
            return new Date();
        }
        return new Date(value);
    };
    return (_jsx(Controller, { name: name, control: control, rules: { required: isRequired }, render: ({ field: { onChange, value } }) => (_jsx(FormControlWrapper, Object.assign({ isInvalid: isError, isRequired: isRequired, error: error, label: label, labelProps: labelProps }, { children: _jsx(BaseDateInput, { onChange: onChange, value: dateValue(value), isInvalid: isError }) }))) }));
};
export default DateInput;
